import React, { useState } from "react";
import { Grid, Typography } from "@material-ui/core";
import { Icon } from "@iconify/react";
import { Box, IconButton, InputAdornment } from "@mui/material";
import { InputField, DatePickerField, SelectField } from "../../FormFields";

import eyeFill from "@iconify/icons-eva/eye-fill";
import eyeOffFill from "@iconify/icons-eva/eye-off-fill";

const titleName = [
  {
    thai: [
      {
        value: "ศาสตราจารย์",
        label: "ศาสตราจารย์",
      },
      {
        value: "ศาสตราจารย์ ดร.",
        label: "ศาสตราจารย์ ดร.",
      },
      {
        value: "รศ.ดร.",
        label: "รศ.ดร.",
      },
      {
        value: "ผศ.ดร.",
        label: "ผศ.ดร.",
      },
      {
        value: "ดร.",
        label: "ดร.",
      },
      {
        value: "อื่นๆ",
        label: "อื่นๆ",
      },
    ],
    eng: [
      {
        value: "Prof",
        label: "Prof.",
      },
      {
        value: "ProfDr",
        label: "Prof. Dr.",
      },
      {
        value: "AssocProfDr",
        label: "Assoc. Prof. Dr.",
      },
      {
        value: "AsstProfDr",
        label: "Asst. Prof. Dr.",
      },
      {
        value: "Dr",
        label: "Dr.",
      },
      {
        value: "Other",
        label: "Other",
      },
    ],
  },
];

export default function FormInformation(props) {
  const {
    formField: {
      //page1
      email,
      password,
      academicTitle,
      nameEng,
      middleNameEng,
      surnameEng,
      titleNameThai,
      nameThai,
      middleNameThai,
      surnameThai,
    },
  } = props;

  const [showPassword, setShowPassword] = useState(false);

  return (
    <>
      <Box sx={{ marginBottom: 3 }}>
        <Typography variant="h6" gutterBottom>
          Personal Information
        </Typography>
      </Box>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <InputField
            type="email"
            name={email.name}
            label={email.label}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputField
            // autoComplete="current-password"
            type={showPassword ? "text" : "password"}
            name={password.name}
            label={password.label}
            fullWidth
            variant="outlined"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    edge="end"
                    onClick={() => setShowPassword((prev) => !prev)}
                  >
                    <Icon icon={showPassword ? eyeFill : eyeOffFill} />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <SelectField
            name={academicTitle.name}
            label={academicTitle.label}
            data={titleName[0].eng}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={8}>
          <InputField
            name={nameEng.name}
            label={nameEng.label}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputField
            name={middleNameEng.name}
            label={middleNameEng.label}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputField
            name={surnameEng.name}
            label={surnameEng.label}
            fullWidth
            variant="outlined"
          />
        </Grid>

        <Grid item xs={12} sm={5}>
          <SelectField
            name={titleNameThai.name}
            label={titleNameThai.label}
            data={titleName[0].thai}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={7}>
          <InputField
            name={nameThai.name}
            label={nameThai.label}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputField
            name={middleNameThai.name}
            label={middleNameThai.label}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputField
            name={surnameThai.name}
            label={surnameThai.label}
            fullWidth
            variant="outlined"
          />
        </Grid>
      </Grid>
    </>
  );
}
